import { z } from 'zod';
import { trackError } from '#api/errors.ts';

export const INVALID_ERR = 'Invalid URL path';
export const TOO_LONG = 'Must be less than 255 characters long';
export const MUST_START_WITH_SLASH = "Must start with a '/'";
export const DOT_NOT_ALLOWED = 'Period character not allowed';

export const statsPathSchema = z
  .string()
  .max(255, TOO_LONG)
  .startsWith('/', MUST_START_WITH_SLASH)
  .refine((value) => !value.includes('.'), DOT_NOT_ALLOWED)
  .refine((value) => {
    try {
      // does the browser parse it?
      new URL(value, 'https://example.com');
      return true;
    } catch (e) {
      if (e instanceof TypeError) {
        return false;
      }
      trackError(e);
      return false;
    }
  }, INVALID_ERR)
  .or(z.literal(''));
